import { SECTION, SECTION_H } from "#puf/constants.ts";

interface LayerInfo {
  id: string;
  visible: boolean;
}

interface Props {
  layers: LayerInfo[];
  currentLayerId: string | undefined;
  onSelect: (id: string) => void;
  onToggleVisibility: (id: string, currentlyVisible: boolean) => void;
  onDelete: (id: string) => void;
  onAddLayer: () => void;
}

export function LayersPanel({
  layers,
  currentLayerId,
  onSelect,
  onToggleVisibility,
  onDelete,
  onAddLayer,
}: Props) {
  return (
    <aside className="border-t border-line bg-bg-2 lg:border-t-0 lg:border-l lg:overflow-y-auto lg:col-start-3 lg:row-span-2">
      <div className={SECTION}>
        <h3 className={SECTION_H}>Layers</h3>
        {layers.map((layer) => {
          const active = currentLayerId === layer.id;
          return (
            <div
              key={layer.id}
              className={`flex items-center gap-2 p-2 rounded-sm mb-1.5 bg-bg-3 border ${
                active ? "border-accent" : "border-line"
              }`}
            >
              <button
                type="button"
                aria-pressed={active}
                aria-label={layer.id}
                onClick={() => {
                  onSelect(layer.id);
                }}
                className="flex-1 text-left cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent"
              >
                {layer.id}
              </button>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onToggleVisibility(layer.id, layer.visible);
                }}
                aria-pressed={layer.visible}
                aria-label={`toggle visibility of ${layer.id}`}
                title={layer.visible ? "Hide" : "Show"}
                className="bg-transparent border border-line text-dim w-5.5 h-5.5 rounded-[3px] cursor-pointer text-[10px]"
              >
                {layer.visible ? "👁" : "–"}
              </button>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(layer.id);
                }}
                disabled={layers.length <= 1}
                aria-label={`delete ${layer.id}`}
                title="Delete"
                className="bg-transparent border border-line text-dim w-5.5 h-5.5 rounded-[3px] cursor-pointer text-[10px] disabled:opacity-50 disabled:cursor-not-allowed"
              >
                ✕
              </button>
            </div>
          );
        })}
        <button
          type="button"
          onClick={onAddLayer}
          className="w-full bg-bg-3 border border-line border-dashed text-dim p-1.5 rounded-sm cursor-pointer"
        >
          + Add layer
        </button>
      </div>
    </aside>
  );
}
